import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { conditions, controllbarIconSize } from "../../../../../helpers";
import { ConditionName, ILockIconProps } from "../../../../../interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const LockIcon = ({ onClick, className, style }: ILockIconProps) => {
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    onClick={onClick}
                    className={`fa-solid fa-lock pl-text-white pl-cursor-pointer ${
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.otherFontAwesome
                            : controllbarIconSize.miniPlayerFontAwesome
                    } ${className}`}
                    style={style}
                />
            ) : (
                <Image
                    src={IMAGES.lock}
                    alt="lock-icon"
                    className={`pl-cursor-pointer ${className}`}
                    style={style}
                    width={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    height={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    onClick={onClick}
                />
            )}
        </>
    );
};

export default LockIcon;
